import { render, staticRenderFns } from "./SmsTab.vue?vue&type=template&id=8ad8b7fa&"
import script from "./SmsTab.vue?vue&type=script&lang=ts&"
export * from "./SmsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports